import { Component, OnInit, Input } from '@angular/core';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { Learnspace, Hub, User, HubUserRole } from '@shared/models';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-manage-user-access',
  templateUrl: './manage-user-access.component.html',
  styleUrls: ['./manage-user-access.component.scss']
})
export class ManageUserAccessComponent implements OnInit {
  @Input() user: User;
  @Input() hub: Hub;

  userLsList: Learnspace[] = [];
  role: string;
  changes: any = {};
  constructor(
    private _courseService: CoursesAPIService,
    public dialogRef: MatDialogRef<ManageUserAccessComponent>,
  ) { 
  }

  ngOnInit(): void {
    this.role = this.user.HubsUsers.role;
    this._courseService.getAssocitatedLearnspacesByUserIdByHubId(this.user.id, this.hub.id)
      .subscribe(lsList => this.userLsList = lsList);
  }

  isAdmin(): boolean {
    return this.role === HubUserRole.admin;
  }
  isInUserList(learnspaceId: string): boolean {
    return this.userLsList.find(ls => ls.id === learnspaceId) !== undefined;
  }

  addToList(learnspaceId: string, event: MatCheckboxChange): void {
    this.changes[learnspaceId] = event.checked;
  }

  commitChanges(): void {
    let subscribeTo, unsubscribeTo;
    if (!this.isAdmin()) {
      subscribeTo = Object.keys(this.changes).filter(c => this.changes[c] === true);
      unsubscribeTo = Object.keys(this.changes).filter(c => this.changes[c] === false);
    }
    this._courseService.associateUserToHub(
      this.hub.id,
      this.user.id,
      this.role,
      subscribeTo,
      unsubscribeTo
    ).subscribe(() => { this.dialogRef.close(); });
  }

  close(): void {
    this.dialogRef.close(this.role);
  }
}
